"use strict";
/* CONSTS */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOOSELY_IMMUTABLE_METHODS = exports.STRICTLY_IMMUTABLE_METHODS = exports.CONSTRUCTORS_UNSUPPORTED = exports.CONSTRUCTORS_SUPPORTED = exports.CONSTRUCTORS_COMPARABLE = exports.CONSTRUCTORS_MUTABLE = exports.CONSTRUCTORS_IMMUTABLE = exports.$GET_RECORD_STOP = exports.$GET_RECORD_START = exports.$STOP = exports.$TARGET = exports.$IS_PROXY = exports.IS_DEVELOPMENT = void 0;
const IS_DEVELOPMENT = (typeof process === 'object') && (process.env.NODE_ENV === 'development');
exports.IS_DEVELOPMENT = IS_DEVELOPMENT;
/* SYMBOLS */
const $IS_PROXY = Symbol('Is Proxy');
exports.$IS_PROXY = $IS_PROXY;
const $TARGET = Symbol('Proxy -> Target');
exports.$TARGET = $TARGET;
const $STOP = Symbol('Stop proxying');
exports.$STOP = $STOP;
const $GET_RECORD_START = Symbol('Start recording get paths');
exports.$GET_RECORD_START = $GET_RECORD_START;
const $GET_RECORD_STOP = Symbol('Stop recording get paths');
exports.$GET_RECORD_STOP = $GET_RECORD_STOP;
/* CONSTRUCTORS */
const CONSTRUCTORS_ERRORS = new Set([
    Error,
    EvalError,
    RangeError,
    ReferenceError,
    SyntaxError,
    TypeError,
    URIError
]);
const CONSTRUCTORS_IMMUTABLE = new Set([
    ...CONSTRUCTORS_ERRORS,
    ArrayBuffer,
    Boolean,
    DataView,
    Number,
    RegExp,
    String,
    Symbol
]);
exports.CONSTRUCTORS_IMMUTABLE = CONSTRUCTORS_IMMUTABLE;
const CONSTRUCTORS_MUTABLE = new Set([
    (function* () { }).constructor,
    (function () {
        return __awaiter(this, void 0, void 0, function* () { });
    }).constructor,
    Date,
    Function,
    Map,
    Object,
    Set,
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
]);
exports.CONSTRUCTORS_MUTABLE = CONSTRUCTORS_MUTABLE;
const CONSTRUCTORS_COMPARABLE = new Set([
    Array,
    ArrayBuffer,
    RegExp,
    Map,
    Set,
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
]);
exports.CONSTRUCTORS_COMPARABLE = CONSTRUCTORS_COMPARABLE;
if (typeof BigInt === 'function') {
    CONSTRUCTORS_IMMUTABLE.add(BigInt);
    if (typeof BigInt64Array === 'function') {
        CONSTRUCTORS_MUTABLE.add(BigInt64Array);
        CONSTRUCTORS_COMPARABLE.add(BigInt64Array);
    }
    if (typeof BigUint64Array === 'function') {
        CONSTRUCTORS_MUTABLE.add(BigUint64Array);
        CONSTRUCTORS_COMPARABLE.add(BigUint64Array);
    }
}
if (typeof SharedArrayBuffer === 'function') {
    CONSTRUCTORS_IMMUTABLE.add(SharedArrayBuffer);
}
const CONSTRUCTORS_SUPPORTED = new Set([
    ...CONSTRUCTORS_IMMUTABLE,
    ...CONSTRUCTORS_MUTABLE,
    ...CONSTRUCTORS_COMPARABLE
]);
exports.CONSTRUCTORS_SUPPORTED = CONSTRUCTORS_SUPPORTED;
const CONSTRUCTORS_UNSUPPORTED = new Set([
    Promise,
    WeakMap,
    WeakSet
]);
exports.CONSTRUCTORS_UNSUPPORTED = CONSTRUCTORS_UNSUPPORTED;
/* METHODS */ // We are assuming the following methods don't get messed up with, and custom methods with the same name that are mutating are not defined
const STRICTLY_IMMUTABLE_METHODS = new Set([
    /* OBJECT */
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf',
    /* ARRAY */
    'includes',
    'indexOf',
    'join',
    'lastIndexOf',
    'toLocaleString',
    'toString',
    /* MAP & SET */
    'has',
    /* DATE */
    'getDate',
    'getDay',
    'getFullYear',
    'getHours',
    'getMilliseconds',
    'getMinutes',
    'getMonth',
    'getSeconds',
    'getTime',
    'getTime',
    'getTimezoneOffset',
    'getUTCDate',
    'getUTCDay',
    'getUTCFullYear',
    'getUTCHours',
    'getUTCMilliseconds',
    'getUTCMinutes',
    'getUTCMonth',
    'getUTCSeconds',
    'getYear',
    /* REGEX */
    'exec',
    'test',
    /* TYPED ARRAY */
    'subarray'
]);
exports.STRICTLY_IMMUTABLE_METHODS = STRICTLY_IMMUTABLE_METHODS;
const LOOSELY_IMMUTABLE_METHODS = {
    array: new Set([
        'concat',
        'entries',
        'every',
        'filter',
        'find',
        'findIndex',
        'forEach',
        'keys',
        'map',
        'reduce',
        'reduceRight',
        'slice',
        'some',
        'values'
    ]),
    others: new Set([
        /* MAP & SET */
        'entries',
        'forEach',
        'get',
        'keys',
        'values'
    ])
};
exports.LOOSELY_IMMUTABLE_METHODS = LOOSELY_IMMUTABLE_METHODS;
